// src/Homepage.js
import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";


function Reports() {
  return (
    <div className="min-vh-100 d-flex flex-column">
      <nav className="navbar navbar-light border-bottom">
        <div className="container-fluid">
          <span className="navbar-brand mb-0 h1">Reports</span>
        </div>
      </nav>
    </div>
  );
}

export default Reports;
